import React from "react"
export default function AttendanceList(){
    return <h1> Attendance</h1>
}